module.exports = __webpack_public_path__ + "static/media/mu.93c49e76.svg";